// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__+0Nvg","selected":"Chip_selected__2z55U","icon":"Chip_icon__FAP84"};